module.exports = __webpack_public_path__ + "static/media/u-shape_distance.2de56a07.svg";